export const AUDIO_BUTTON_CLICK_EVENT = "AUDIO_BUTTON_CLICK_EVENT";

export interface AudioButtonData {
  name: string,
  url: string,
  directUrl: string
}